module.exports = __webpack_public_path__ + "img/individual-subscriber-agreement.47e26bb3.svg";